<template>
  <router-view/>
</template>

<script>
export default {
  methods: {
    removeParam(key, sourceURL) {
      var rtn = sourceURL.split("?")[0],
          param, params_arr = [],
          queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },
  },
  created() {
    let store = this.$store
    let utmList = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
    ];
    let urlObject = {};
    let utmObj = {};

    try {
      urlObject = new URL(window.location.href);
      for (let utmItem of utmList) {
        let val = urlObject.searchParams.get(utmItem);
        if (val) {
          localStorage.removeItem(utmItem)
          localStorage.setItem(utmItem, val)
          store.commit('setUtm', {type: utmItem, items: val})
        }
      }
    }
    catch (e) {
      console.log("e: ", e);
    }
    let origUrl = window.location.href

    origUrl = this.removeParam('utm_source', origUrl)
    origUrl = this.removeParam('utm_medium', origUrl)
    origUrl = this.removeParam('utm_campaign', origUrl)
    origUrl = this.removeParam('utm_content', origUrl)
    origUrl = this.removeParam('utm_term', origUrl)
    window.location.href = origUrl
    //?utm_source=Website&utm_medium=cpc&utm_campaign=quiz_test&utm_content=lending
  }
}
</script>

<style lang="scss">
@import "~assets/css/app.css";
</style>
